import classNames from "classnames";
import { keywordMap } from "../../../core/enums";
import {
  GetCitiesAndPrefecturesWithProductsQuery,
  Location,
} from "../../../graphql/operations";
import { getCityUrl } from "../../../utils/getCityUrl";
import Loader from "../../Atoms/Loader";
import { Text } from "../../Atoms/Typography";
import styles from "./Header.module.scss";

export type DestinationPickerLocation =
  GetCitiesAndPrefecturesWithProductsQuery["locations"]["records"][number];

type DestinationPickerProps = {
  locations: DestinationPickerLocation[];
  onCityPick: (locationId: Location["id"] | undefined) => void;
  selectedId?: string;
  includeAnywhere?: boolean;
  countryId?: string;
  loading?: boolean;
};

export default function DestinationPicker({
  onCityPick,
  selectedId,
  locations,
  countryId,
  loading,
}: DestinationPickerProps) {
  if (loading) {
    return (
      <ul className={`${styles.SubMenu} ${styles.DestinationPicker}`}>
        <li style={{ width: 250 }}>
          <Loader />
        </li>
      </ul>
    );
  }

  return (
    <ul className={`${styles.SubMenu} ${styles.DestinationPicker}`}>
      {(countryId
        ? locations.filter((c) => c.country.id === countryId)
        : locations || []
      ).map(
        (location) =>
          location && (
            <DestinationListItem
              key={location.id}
              destinationNames={location.destinationNames}
              id={location.id}
              url={getCityUrl(location)}
              name={location.translation.name}
              onCityPick={onCityPick}
              selectedId={selectedId}
            />
          )
      )}
    </ul>
  );
}

type DestinationListItemsProps = {
  id: Location["id"] | undefined;
  destinationNames: Location["destinationNames"];
  url: string;
  name: Location["translation"]["name"];
} & Pick<DestinationPickerProps, "onCityPick" | "selectedId">;

function DestinationListItem({
  id,
  name,
  onCityPick,
  url,
  selectedId,
  destinationNames,
}: DestinationListItemsProps) {
  return (
    <li key={id} onClick={() => onCityPick(url)}>
      <div
        className={classNames(styles.DestinationPickerItem, {
          [styles.Selected]: id === selectedId,
        })}
      >
        <b>{name}</b>
        <Text size="smaller" muted>
          {destinationNames ?? keywordMap[id]}
        </Text>
      </div>
    </li>
  );
}
